// extracted by mini-css-extract-plugin
export default {"notesPage":"notespage_notesPage__LH0FK","notesGrid":"notespage_notesGrid__Dv1jV","note":"notespage_note__ZEm7t"};